import {Type} from "main.core";

// Загрузка объекта для работы с событиями рекламных баннеров на странице
import {EventAdvertising} from "./eventAdvertising.js";

export class Markadv
{
    constructor(options = {name: "Markadv"})
    {
        this.name = options.name;
        this.eventAdvertising = EventAdvertising;
    }

    setName(name)
    {
        if (Type.isString(name)) {
            this.name = name;
        }
    }

    getName()
    {
        return this.name;
    }
}
